<template>
  <div>
    <dt>{{ label }}</dt>
    <dd>{{ value }}</dd>
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-disciplina",
  props: {
    label: String,
    value: String,
    login: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/Disciplina.vue